import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from "framer-motion"


const PolicyComp = () => {
    return ( 
        <>
        <div className="main_cont fixed-top">
          <nav className=" pe-3 mobile_cont d-none nav_cont">
            <ul>
                <a href="/"><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"15%"}}/></a> 
              <div className="d-inline pt-4" style={{"float":"right","letterSpacing":"4px"}}>
              <Link to={"/signup"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center activ_box" > <p className="activ">Free Offer</p></div></Link>
              <Link to={"/"}  className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Home</div></Link>
              <Link to={"/templates"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Websites</div></Link>
              <Link to={"/about"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >About</div></Link>
              <Link to={"/policy"} className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Policy</div></Link>
              <a href="/" className="nav_hid text-decoration-none mx-4 text-light"><div className="nav_box text-center" >Contact</div></a>
              </div>
            </ul>
          </nav>
        

<nav className="mobile_cont d-md-none fixed-top">
<button style={{"background":"none"}} className="btn btn-white ms-3 my-4" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions"><i className="fa fa-bars" style={{"fontSize":"30px"}} aria-hidden="true"></i>
</button> <Link to={'/signin'}><button style={{"background":"none"}} className="btn btn-white" type="button" ><i class="fa fa-phone fw-bold text-success" style={{"fontSize":"30px"}} aria-hidden="true"></i></button></Link>
<a href='#home'><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline mx-5 my-4" style={{"width":"25%", "float":"right","transform":"scale(1.9)"}}/></a>
<div className="offcanvas offcanvas-start w-50" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
  <div className="offcanvas-header">
    <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel"><Link><img src="/images/business_logo.png" alt="logo" className="img-fluid d-inline" style={{"width":"60%", "float":"left","transform":"scale(1.8)"}}/></Link>
</h5>
    <button type="button" className="btn-close btn-danger" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="mob offcanvas-body text-white" style={{ backgroundColor: "#E52020", textAlign: "center" }}>
  <Link to={"/signup"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Offer
    </div>
  </Link>
  <Link to={"/"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Home
    </div>
  </Link>
  <Link to={"/templates"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
      Websites
    </div>
  </Link>
  <Link to={"/about"} style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       About
    </div>
  </Link>
  <Link to="/policy" style={{ textDecoration: "none" }}>
    <div className="w-100 p-3 text-white" style={{ fontSize: "20px" }}>
       Policy
    </div>
  </Link>
  <a href={"#contact"} style={{ textDecoration: "none" }}>
    <div className="a_log w-100 p-3 mt-3 text-white" style={{ fontSize: "20px" }}>
      Contact
    </div>
  </a>
</div>

</div>
</nav>
        </div>

  
          <div class="container mt-5 pt-5">
            <div className="text-center">
            <i class="fa fa-globe fs-1" aria-hidden="true"style={{color: "#000080"}}></i>
          <h3 className="text-center">Our Policy</h3>
            </div>
      <hr className="hr_line"></hr>
        <div>
          <h3>Privacy Policy</h3>
          <p>At Carib Web Works, we take your privacy seriously. 
		  This Privacy Policy describes how we collect, use, and disclose your personal information when you use our website or services. 
		  By using our website or services, you consent to the collection, use, and disclosure of your personal information as described in this Privacy Policy.</p>
        </div>
		
		<h5>Collection of Information</h5>
		  <p>We may collect personal information such as your name, email address, 
		 and phone number when you fill out a form on our website or when you communicate with us through email or phone. 
		 We may also collect non-personal information such as your IP address, browser type, and referring URL.</p>
		
		<h5>Use of Information</h5> 
		  <p>We use the information we collect to provide you with our services, to communicate with you, to improve our website and services, and to personalize your experience. We may also use the information to respond to your inquiries, 
		  to send you marketing emails, and to comply with legal obligations.</p>
		
		<h5>Disclosure of Information</h5> 
		  <p>We do not sell or rent your personal information to third parties. We may disclose your personal information to our service providers who assist us in providing our services, 
		  to comply with legal obligations, or to protect our rights and property. 
		  We may also disclose your personal information if we believe that disclosure is necessary to prevent harm or injury.</p>
		
		<h5>Security of Information</h5> 
		  <p>We take reasonable measures to protect the personal information we collect from unauthorized access, use, or disclosure.</p>
		
		<h5>Links to Third-Party Websites</h5> 
		  <p>Our website may contain links to third-party websites that are not under our control. We are not responsible for the privacy practices or content of those websites. 
		  We encourage you to read the privacy policies of those websites.</p>
		  
		  <h5>Changes to Privacy Policy</h5> 
		  <p>We may update this Privacy Policy from time to time. We will post the updated Privacy Policy on our website and indicate the date of the last revision.
		  Your continued use of our website or services after the posting of any changes to this Privacy Policy means you accept those changes.</p>
		
		<h5>Contact Us</h5> 
		  <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@caribwebworks.com"><span class="text-info">info@caribwebworks.com</span></a></p>
      
	    <h4 class="text-success">Terms & Condition</h4>
	  
	     <p>Welcome to Carib Web Works! We are a website design business based in Jamaica. Our goal is to provide high-quality web design services to our clients. 
		 Before using our services, please read these Terms and Conditions carefully.</p>
	  
	   <h5>Introduction</h5>
	    <p>By accessing or using our services, you agree to be bound by these Terms and Conditions. 
		If you do not agree to these Terms and Conditions, you may not use our services.</p>
	  
	    <h5>Services</h5>
	    <p>We offer web design services, including but not limited to website design and development, 
		website hosting, website maintenance, and website optimization.</p>
	  
	     <h5>Payment</h5>
	    <p>We require a deposit before starting any project. The deposit amount will be discussed with the client before the start of the project. 
		The remaining balance is due upon completion of the project.</p>
	  
	  
	    <h5>Content</h5>
	    <p>The client is responsible for providing all content for the website, including text, images, videos, and other media. 
		The client warrants that all content provided does not infringe any third-party rights, including but not limited to copyright, trademark, or privacy rights.</p>
	  
	    <h5>Intellectual Property</h5>
	    <p>We retain all intellectual property rights to the website design and development, including but not limited to the code, graphics, and other elements of the website. The client may not reproduce, distribute, 
		or use any part of the website design without our prior written consent</p>
	  
	  
	     <h5>Liability</h5>
	    <p>We will not be liable for any loss or damage arising from the use of our services, including but not limited to loss of profits, data, or business interruption. 
		We will not be liable for any third-party claims arising from the use of the website.</p>
	  
	  
	    <h5>Confidentiality</h5>
	    <p>We will keep all client information confidential and will not disclose any information to third parties without the client's prior written consent.</p>
	  
	    <h5>Termination</h5>
	    <p>Either party may terminate the agreement at any time with written notice. Upon termination, 
		the client will pay for all services provided up to the termination date.</p>
	   
	   <h5>Governing Law</h5>
	    <p>These Terms and Conditions are governed by the laws of the Caribbean. 
		Any disputes arising from these Terms and Conditions will be resolved court.</p>
	   
	   <h5>Modification</h5>
	    <p>We reserve the right to modify these Terms and Conditions at any time. Any changes will be effective immediately upon posting on our website. 
		Your continued use of our services after any such changes constitutes your acceptance of the revised Terms and Conditions.</p>
	   <br/>If you have any questions about these Terms and Conditions, please contact us at caribwebworks@gmail.com.
  </div>

                                 {/*footer section*/} 
           <div className="body-footer text-center text-white" id="contact" style={{"backgroundColor":"#E52020"}}>
            <footer className="w-100 py-4 flex-shrink-0">
                <div className="container py-4">
                    <div className="row gy-4 gx-5">
                        <div className="col-lg-4 col-md-6">
                            <h5 className="h1 text-white">Contact Us</h5>
                            <p className="small text-white">Call: (876) 808-9990</p>
                            <p className="small text-white">Watsapp: (876) 808-9990</p>
                            <p className="small text-white">Email: caribwebworks@gmail.com </p>
                            <p className="small text-white">Address: Montego Bay, St. James</p>
                            <p><i class="fa fa-twitter-square me-3" aria-hidden="true"></i> 
                           <i class="fa fa-instagram me-3" aria-hidden="true"></i>
                            <i class="fa fa-facebook-square me-3" aria-hidden="true"></i>
                            </p>   
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled text-dark">
                                <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="/" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <h5 className="text-white mb-3">Menu</h5>
                            <ul className="list-unstyled">
                            <li><a className="text-warning fw-bold"  href="/">Home</a></li>
                                <li><Link className="text-warning fw-bold"  to={"/about"}>About</Link></li>
                                <li><Link className="text-warning fw-bold"  to={"/policy"}>Policy</Link></li>
                                <li><a className="text-warning fw-bold"  href="/" >FAQ</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-6">
                        <h3 className="h1 text-white">Carib Web Works</h3>
                            <img src="/images/business_logo1.png" alt="logo" className="img-fluid d-inline my-2" style={{"width":"40%","transform":"scale(1.2)"}}/>
                            <p className="small" style={{"color":"gold"}}>"Attract more customers with digital marketing"</p>
                            <i>By: Ceo & Team</i>
                        </div>
                    </div>
                </div>
                <p className="small text-dark mb-0" id="contact">&copy; Copyrights. All rights reserved. <a className="text-primary" href="/signup" target={'_blank'}>caribwebworks.com</a></p>
            </footer>
                </div>
        </>
     );
}
 
export default PolicyComp;